<template>
  <div class="Leave" style="margin-top:1px;">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div ref="fresh" :style="{height:freshHeight +'px','overflow-y':'scroll','box-sizing': 'border-box','padding-bottom':'100px'}">
        <van-checkbox-group ref="checkboxGroup" v-model="result">
          <van-swipe-cell v-for="(info, index) in workLeaves" :key="info.leave_num" clickable>
            <van-cell :title="info.user_name" @click="toggle(index)">
              <template v-if="info.approval === '0' || info.approval === '3'" #icon>
                <van-checkbox ref="checkboxes" :name="info.leave_num" icon-size="16px" style="margin-right:10px" />
              </template>
              <template slot="label">
                <span>{{ info.reason }}</span>
                <br>
                <span>{{ worktimeChange(info) }}</span>
                <br>
              </template>
              <span>{{ leaveTypeChange(info) }}</span>
              <br>
              <span :style="{ color: leaveStatusSet(info.approval)}">{{ approvalStatusChange(info) }}</span>
            </van-cell>
            <template v-if="info.approval === '0' || info.approval === '3'" #right>
              <van-button square text="同意" type="primary" class="button-size" @click="onClickCommit(info)" />
              <van-button square text="拒绝" type="danger" class="button-size" @click="onClickNotCommit(info)" />
            </template>
          </van-swipe-cell>
        </van-checkbox-group>
      </div>
    </van-pull-refresh>
    <van-tabbar v-if="$parent.params.approval === '0'" style="bottom:50px;">
      <van-tabbar-item style="align-items: flex-start;padding-left: 16px;">
        <van-checkbox v-model="checked" icon-size="16px" @click="checkAll">全选</van-checkbox>
      </van-tabbar-item>
      <van-tabbar-item style="align-items: flex-end;padding-right: 16px;">
        <van-button type="primary" size="small" @click="onClickAllCommit()">同意</van-button>&nbsp;&nbsp;&nbsp;
        <van-button type="danger" size="small" @click="onClickAllNoCommit()">拒绝</van-button>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { Notify } from 'vant'
import request from '@/utils/request'
const moment = require('moment')
const approvals = { '0': '未批准', '1': '已批准', '2': '已拒绝', '3': '审批中' }
export default {
  name: 'Approval',
  data() {
    return {
      workLeaves: [],
      isLoading: false,
      freshHeight: '100%',
      result: [],
      checked: false,
      checkedAll: false
    }
  },
  watch: {
    result() {
      if (this.result.length === this.workLeaves.length) {
        this.checked = true
      } else {
        this.checked = false
      }
    }
  },
  created: function() {
    this.onRefresh()
  },
  mounted() {
    this.freshHeight = document.documentElement.clientHeight - this.$refs.fresh.getBoundingClientRect().top
  },
  methods: {
    // 获取人名
    worktimeChange(info) {
      if (info.leave_flg === '0') {
        return moment(info.leave_time_s).format('YYYY-MM-DD') + '~' + moment(info.leave_time_e).format('YYYY-MM-DD')
      } else {
        return moment(info.leave_time_s).format('YYYY-MM-DD') + ' ' + moment(info.leave_time_s).format('HH:mm') + '-' + moment(info.leave_time_e).format('HH:mm')
      }
    },
    // 请假类型
    leaveTypeChange(info) {
      const status = this.GLOBAL.BASE_LEAVE_STATUS
      return status[info.leave_type]
    },
    // 状态区分
    approvalStatusChange(info) {
      return approvals[info.approval]
    },
    // 状态颜色区分
    leaveStatusSet(approval) {
      switch (approval) {
        case '1': return 'green'
        case '2': return 'red'
        case '3': return 'blue'
        default: return 'orange'
      }
    },
    // 单选
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
    // 全选
    checkAll() {
      this.checked = !this.checked
      this.checkedAll = !this.checkedAll
      this.$refs.checkboxGroup.toggleAll(this.checkedAll)
    },
    toggleAll() {
      this.$refs.checkboxGroup.toggleAll()
    },
    // 审批一条
    messageNotificationOne(info) {
      let approve_user_code // eslint-disable-line no-unused-vars
      // 当前用户为第一审批人 且 第二审批人未审批
      if (info.approval_user1 === this.$store.getters.usercode && info.approval2 === '0') {
        // 第一审批人 第二审批人是同一人
        if (info.approval_user1 === info.approval_user2) {
          // 第一审批人 第二审批人 第三审批人都是同一人
          if (info.approval_user2 === info.approval_user3) {
            approve_user_code = ''
          // 第一审批人 第二审批人 是同一人 第二审批人和第三审核人不是同意一人
          } else {
            approve_user_code = info.approval_user3
          }
        // 第一审批人 第二审批人不是同一人
        } else {
          approve_user_code = info.approval_user2
        }
      // 当前用户为第二审批人 且 第三审批人未审批
      } else if (info.approval_user2 === this.$store.getters.usercode && info.approval3 === '0') {
        // 当前用户为第二审批人和第三审批人不是同一人
        if (info.approval_user2 !== info.approval_user3) {
          approve_user_code = info.approval_user3
        }
      }
      // 消息通知接口
      request({ url: 'O00/MessageOne', params: { user_code: approve_user_code, please_user_code: info.leave_target }})
        .then(function(response) {

        })
        .catch(function(error) {
          self.$toast.fail(error)
        })
      if (approve_user_code === '2008001') {
        // 消息通知接口
        request({ url: 'O00/MessageOne', params: { user_code: '2012077', please_user_code: info.leave_target }})
          .then(function(response) {
          })
          .catch(function(error) {
            self.$toast.fail(error)
          })
      }
    },
    // 审批多条
    messageNotificationAll() {
      const primaryArray = []
      this.result.forEach((leaveNum, index) => {
        const info = this.workLeaves.filter(v => String(v.leave_num).indexOf(leaveNum) > -1)[0]
        const approve_user_code = {}
        // 当前用户为第一审批人 且 第二审批人未审批
        if (info.approval_user1 === this.$store.getters.usercode && info.approval2 === '0') {
          // 第一审批人 第二审批人是同一人
          if (info.approval_user1 === info.approval_user2) {
            // 第一审批人 第二审批人 第三审批人都是同一人
            if (info.approval_user2 === info.approval_user3) {
              approve_user_code.user_code = ''
              approve_user_code.applicant_code = ''
            // 第一审批人 第二审批人 是同一人 第二审批人和第三审核人不是同意一人
            } else {
              approve_user_code.user_code = info.approval_user3
              approve_user_code.applicant_code = info.leave_target
            }
          // 第一审批人 第二审批人不是同一人
          } else {
            approve_user_code.user_code = info.approval_user2
            approve_user_code.applicant_code = info.leave_target
          }
        // 当前用户为第二审批人 且 第三审批人未审批
        } else if (info.approval_user2 === this.$store.getters.usercode && info.approval3 === '0') {
          // 当前用户为第二审批人和第三审批人不是同一人
          if (info.approval_user2 !== info.approval_user3) {
            approve_user_code.user_code = info.approval_user3
            approve_user_code.applicant_code = info.leave_target
          }
        } else {
          approve_user_code.user_code = ''
          approve_user_code.applicant_code = ''
        }
        primaryArray.push(approve_user_code)
        if (approve_user_code.user_code === '2008001') {
          const aaa = {}
          aaa.user_code = '2012077'
          aaa.applicant_code = approve_user_code.applicant_code
          primaryArray.push(aaa)
        }
      })
      // 消息通知接口
      request({ url: 'O00/MessageAll', method: 'post', data: primaryArray })
        .then(function(response) {

        })
        .catch(function(error) {
          self.$toast.fail(error)
        })
    },
    // 同意
    onClickAllCommit() {
      if (this.result.length === 0) {
        Notify({ type: 'warning', message: '请选择项目' })
      } else {
        const datas = []
        // let returnState = true // eslint-disable-line no-unused-vars
        this.$dialog.confirm({ title: '确认信息', message: '是否确定执行操作？' })
          .then(() => {
            this.messageNotificationAll()
            this.result.forEach(leaveNum => {
              const element = this.workLeaves.filter(v => String(v.leave_num).indexOf(leaveNum) > -1)[0]
              // // 当前用户为第二审核人， 第一审核人未审核
              // if ((element.approval_user2 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user2 === '2008001')) && element.approval1 === '0') {
              //   // 第一审核人和第二审核人不是同一人
              //   if (element.approval_user1 !== element.approval_user2) {
              //     if (element.approval_user1 !== '2012077' && element.approval_user2 !== '2008001' && element.approval1 !== '1') {
              //       // 提示‘第一审批人承认后才可执行此操作。’
              //       Notify({ type: 'warning', message: '第一审批人未审核，该操作不可执行。' })
              //       // 停止执行
              //       returnState = false
              //       return false
              //     }
              //   }
              // // 当前用户为第三审核人，第一审核人未审核
              // } else if ((element.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user3 === '2008001')) && element.approval1 === '0') {
              //   // 第一审核人和第二审核人不是同一人
              //   if (element.approval_user1 !== element.approval_user2) {
              //     // 提示‘第一审批人承认后才可执行此操作。’
              //     Notify({ type: 'warning', message: '第一审批人未审核，该操作不可执行。' })
              //     // 停止执行
              //     returnState = false
              //     return false
              //   // 第一审核人和第二审核人是同一人，且第一审核人和第二审核人都未审核
              //   } else if (element.approval_user1 === element.approval_user2 && element.approval2 === '0') {
              //     // 提示‘第一审批人承认后才可执行此操作。’
              //     Notify({ type: 'warning', message: '第二审批人未审核，该操作不可执行。' })
              //     // 停止执行
              //     returnState = false
              //     return false
              //   }
              // // 当前用户为第三审核人， 第二审核人未审核
              // } else if ((element.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user3 === '2008001')) && element.approval2 === '0') {
              //   // 第二审核人和第三审核人不是同一人
              //   if (element.approval_user2 !== element.approval_user3) {
              //     if (element.approval_user2 !== '2012077' && element.approval_user3 !== '2008001') {
              //       // 提示‘第二审批人承认后才可执行此操作。’
              //       Notify({ type: 'warning', message: '第二审批人未审核，该操作不可执行。' })
              //       // 停止执行
              //       returnState = false
              //       return false
              //     }
              //   }
              // }

              if (element.approval_user1 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user1 === '2008001')) { element.approval1 = '1' }
              if (element.approval_user2 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user2 === '2008001')) { element.approval2 = '1' }
              if (element.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user3 === '2008001')) { element.approval3 = '1' }
              if (element.approval_user === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user === '2008001')) {
                element.approval = '1'
              } else {
                element.approval = '3'
              }

              var obj = element
              // 第一审核人不为空 ，第二 第三审核人为空
              if (obj.approval_user1 !== null && obj.approval_user2 === null && obj.approval_user3 === null) {
                obj.approval_date1 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
                // obj.approval_user1 = this.$store.getters.usercode
              // 第二审核人不为空 ，第三审核人为空
              } else if (obj.approval_user2 !== null && obj.approval_user3 === null) {
                obj.approval_date2 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
                // obj.approval_user2 = this.$store.getters.usercode
              // 第三审核人不为空
              } else if (obj.approval_user3 !== null) {
                obj.approval_date3 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
                // obj.approval_user3 = this.$store.getters.usercode
              }
              obj.leave_num = String(element.leave_num)
              datas.push(obj)
            })
            // if (returnState === true) {
            this.saveData(datas)
            // }
          }).catch(() => {})
      }
    },
    // 拒绝
    onClickAllNoCommit() {
      if (this.result.length === 0) {
        Notify({ type: 'warning', message: '请选择项目' })
      } else {
        const datas = []
        // let returnState = true // eslint-disable-line no-unused-vars
        this.$dialog.confirm({ title: '确认信息', message: '是否确定执行操作？' })
          .then(() => {
            this.result.forEach(leaveNum => {
              const element = this.workLeaves.filter(v => String(v.leave_num).indexOf(leaveNum) > -1)[0]
              // // 当前用户为第二审核人， 第一审核人未审核
              // if ((element.approval_user2 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user2 === '2008001')) && element.approval1 === '0') {
              //   // 第一审核人和第二审核人不是同一人
              //   if (element.approval_user1 !== element.approval_user2) {
              //     if (element.approval_user1 !== '2012077' && element.approval_user2 !== '2008001' && element.approval1 !== '2') {
              //       // 提示‘第一审批人承认后才可执行此操作。’
              //       Notify({ type: 'warning', message: '第一审批人未审核，该操作不可执行。' })
              //       // 停止执行
              //       returnState = false
              //       return false
              //     }
              //   }
              // // 当前用户为第三审核人，第一审核人未审核
              // } else if ((element.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user3 === '2008001')) && element.approval1 === '0') {
              //   // 第一审核人和第二审核人不是同一人
              //   if (element.approval_user1 !== element.approval_user2) {
              //     // 提示‘第一审批人承认后才可执行此操作。’
              //     Notify({ type: 'warning', message: '第一审批人未审核，该操作不可执行。' })
              //     // 停止执行
              //     returnState = false
              //     return false
              //   // 第一审核人和第二审核人是同一人，且第一审核人和第二审核人都未审核
              //   } else if (element.approval_user1 === element.approval_user2 && element.approval2 === '0') {
              //     // 提示‘第一审批人承认后才可执行此操作。’
              //     Notify({ type: 'warning', message: '第二审批人未审核，该操作不可执行。' })
              //     // 停止执行
              //     returnState = false
              //     return false
              //   }
              // // 当前用户为第三审核人， 第二审核人未审核
              // } else if ((element.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user3 === '2008001')) && element.approval2 === '0') {
              //   // 第二审核人和第三审核人不是同一人
              //   if (element.approval_user2 !== element.approval_user3) {
              //     if (element.approval_user2 !== '2012077' && element.approval_user3 !== '2008001') {
              //       // 提示‘第二审批人承认后才可执行此操作。’
              //       Notify({ type: 'warning', message: '第二审批人未审核，该操作不可执行。' })
              //       // 停止执行
              //       returnState = false
              //       return false
              //     }
              //   }
              // }
              if (element.approval_user1 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user1 === '2008001')) { element.approval1 = '2' }
              if (element.approval_user2 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user2 === '2008001')) { element.approval2 = '2' }
              if (element.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && element.approval_user3 === '2008001')) { element.approval3 = '2' }
              element.approval = '2'
              var obj = element
              // 第一审核人不为空 ，第二 第三审核人为空
              if (obj.approval_user1 !== null && obj.approval_user2 === null && obj.approval_user3 === null) {
                obj.approval_date1 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
                // obj.approval_user1 = this.$store.getters.usercode
              // 第二审核人不为空 ，第三审核人为空
              } else if (obj.approval_user2 !== null && obj.approval_user3 === null) {
                obj.approval_date2 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
                // obj.approval_user2 = this.$store.getters.usercode
              // 第三审核人不为空
              } else if (obj.approval_user3 !== null) {
                obj.approval_date3 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
                // obj.approval_user3 = this.$store.getters.usercode
              }
              obj.leave_num = String(element.leave_num)
              datas.push(obj)
            })
            // if (returnState === true) {
            this.saveData(datas)
            // }
          }).catch(() => {})
      }
    },
    // 单条审批
    onClickCommit(info) {
      const datas = []
      this.$dialog.confirm({ title: '确认信息', message: '是否确定执行操作？' })
        .then(() => {
          this.messageNotificationOne(info)
          // // 当前用户为第二审核人， 第一审核人未审核
          // if ((info.approval_user2 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user2 === '2008001')) && info.approval1 === '0') {
          //   // 第一审核人和第二审核人不是同一人
          //   if (info.approval_user1 !== info.approval_user2) {
          //     if (info.approval_user1 !== '2012077' && info.approval_user2 !== '2008001' && info.approval1 !== '1') {
          //       // 提示‘第一审批人承认后才可执行此操作。’
          //       Notify({ type: 'warning', message: '第一审批人未审核，该操作不可执行。' })
          //       // 停止执行
          //       return false
          //     }
          //   }
          // // 当前用户为第三审核人，第一审核人未审核
          // } else if ((info.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user3 === '2008001')) && info.approval1 === '0') {
          //   // 第一审核人和第二审核人不是同一人
          //   if (info.approval_user1 !== info.approval_user2) {
          //     // 提示‘第一审批人承认后才可执行此操作。’
          //     Notify({ type: 'warning', message: '第一审批人未审核，该操作不可执行。' })
          //     // 停止执行
          //     return false
          //   // 第一审核人和第二审核人是同一人，且第一审核人和第二审核人都未审核
          //   } else if (info.approval_user1 === info.approval_user2 && info.approval2 === '0') {
          //     // 提示‘第一审批人承认后才可执行此操作。’
          //     Notify({ type: 'warning', message: '第二审批人未审核，该操作不可执行。' })
          //     // 停止执行
          //     return false
          //   }
          // // 当前用户为第三审核人， 第二审核人未审核
          // } else if ((info.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user3 === '2008001')) && info.approval2 === '0') {
          //   // 第二审核人和第三审核人不是同一人
          //   if (info.approval_user2 !== info.approval_user3) {
          //     if (info.approval_user2 !== '2012077' && info.approval_user3 !== '2008001') {
          //       // 提示‘第二审批人承认后才可执行此操作。’
          //       Notify({ type: 'warning', message: '第二审批人未审核，该操作不可执行。' })
          //       // 停止执行
          //       return false
          //     }
          //   }
          // }
          if (info.approval_user1 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user1 === '2008001')) { info.approval1 = '1' }
          if (info.approval_user2 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user2 === '2008001')) { info.approval2 = '1' }
          if (info.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user3 === '2008001')) { info.approval3 = '1' }
          if (info.approval_user === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user === '2008001')) {
            info.approval = '1'
          } else {
            info.approval = '3'
          }
          var obj = info
          // 第一审核人不为空 ，第二 第三审核人为空
          if (obj.approval_user1 !== null && obj.approval_user2 === null && obj.approval_user3 === null) {
            obj.approval_date1 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
            // obj.approval_user1 = this.$store.getters.usercode
          // 第二审核人不为空 ，第三审核人为空
          } else if (obj.approval_user2 !== null && obj.approval_user3 === null) {
            obj.approval_date2 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
            // obj.approval_user2 = this.$store.getters.usercode
          // 第三审核人不为空
          } else if (obj.approval_user3 !== null) {
            obj.approval_date3 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
            // obj.approval_user3 = this.$store.getters.usercode
          }
          obj.leave_num = String(info.leave_num)
          datas.push(obj)
          this.saveData(datas)
        })
        .catch(() => {})
    },
    // 单条拒绝
    onClickNotCommit(info) {
      const datas = []
      this.$dialog.confirm({ title: '确认信息', message: '是否确定执行操作？' })
        .then(() => {
          // // 当前用户为第二审核人， 第一审核人未审核
          // if ((info.approval_user2 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user2 === '2008001')) && info.approval1 === '0') {
          //   // 第一审核人和第二审核人不是同一人
          //   if (info.approval_user1 !== info.approval_user2) {
          //     if (info.approval_user1 !== '2012077' && info.approval_user2 !== '2008001' && info.approval1 !== '2') {
          //       // 提示‘第一审批人承认后才可执行此操作。’
          //       Notify({ type: 'warning', message: '第一审批人未审核，该操作不可执行。' })
          //       // 停止执行
          //       return false
          //     }
          //   }
          // // 当前用户为第三审核人，第一审核人未审核
          // } else if ((info.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user3 === '2008001')) && info.approval1 === '0') {
          //   // 第一审核人和第二审核人不是同一人
          //   if (info.approval_user1 !== info.approval_user2) {
          //     // 提示‘第一审批人承认后才可执行此操作。’
          //     Notify({ type: 'warning', message: '第一审批人未审核，该操作不可执行。' })
          //     // 停止执行
          //     return false
          //   // 第一审核人和第二审核人是同一人，且第一审核人和第二审核人都未审核
          //   } else if (info.approval_user1 === info.approval_user2 && info.approval2 === '0') {
          //     // 提示‘第一审批人承认后才可执行此操作。’
          //     Notify({ type: 'warning', message: '第二审批人未审核，该操作不可执行。' })
          //     // 停止执行
          //     return false
          //   }
          // // 当前用户为第三审核人， 第二审核人未审核
          // } else if ((info.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user3 === '2008001')) && info.approval2 === '0') {
          //   // 第二审核人和第三审核人不是同一人
          //   if (info.approval_user2 !== info.approval_user3) {
          //     if (info.approval_user2 !== '2012077' && info.approval_user3 !== '2008001') {
          //       // 提示‘第二审批人承认后才可执行此操作。’
          //       Notify({ type: 'warning', message: '第二审批人未审核，该操作不可执行。' })
          //       // 停止执行
          //       return false
          //     }
          //   }
          // }
          if (info.approval_user1 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user1 === '2008001')) { info.approval1 = '2' }
          if (info.approval_user2 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user2 === '2008001')) { info.approval2 = '2' }
          if (info.approval_user3 === this.$store.getters.usercode || (this.$store.getters.usercode === '2012077' && info.approval_user3 === '2008001')) { info.approval3 = '2' }
          info.approval = '2'
          var obj = info
          // 第一审核人不为空 ，第二 第三审核人为空
          if (obj.approval_user1 !== null && obj.approval_user2 === null && obj.approval_user3 === null) {
            obj.approval_date1 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
            // obj.approval_user1 = this.$store.getters.usercode
          // 第二审核人不为空 ，第三审核人为空
          } else if (obj.approval_user2 !== null && obj.approval_user3 === null) {
            obj.approval_date2 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
            // obj.approval_user2 = this.$store.getters.usercode
          // 第三审核人不为空
          } else if (obj.approval_user3 !== null) {
            obj.approval_date3 = this.$moment(new Date()).format('YYYY-MM-DD') + ' ' + this.$moment(new Date()).format('HH:mm:ss')
            // obj.approval_user3 = this.$store.getters.usercode
          }
          obj.leave_num = String(info.leave_num)
          datas.push(obj)
          this.saveData(datas)
        })
        .catch(() => {})
    },
    // 数据保存处理
    saveData(infos) {
      const self = this
      self.$toast.loading({
        duration: 10000,
        message: '加载中...',
        forbidClick: true
      })
      request({ url: 'C04/aprvLeaves/', method: 'post', data: infos })
        .then(function(response) {
          self.onRefresh()
          self.$toast.success('Submit Successed!')
        })
        .catch(function(error) {
          self.isLoading = false
          self.$toast.fail(error)
        })
    },
    // 页面刷新
    onRefresh() {
      const self = this
      self.checked = false
      self.result.length = 0
      self.workLeaves = []
      const params = this.$parent.params
      request({ url: '/C04/aprvLeaves', params: params })
        .then(function(response) {
          if (response.code === 0) {
            if (params.approval === '0') {
              self.workLeaves = response.data.filter(v => v.approval.indexOf('0') > -1 || v.approval.indexOf('3') > -1)
            } else if (params.approval === '1') {
              self.workLeaves = response.data.filter(v => v.approval.indexOf('1') > -1 || v.approval.indexOf('2') > -1)
            } else {
              self.workLeaves = response.data
            }
          }
          self.isLoading = false
        })
        .catch(function(error) {
          self.isLoading = false
          self.$toast.fail(error)
        })
    }
  }
}
</script>
<style scoped>
    .van-cell__value{
      max-width: 30%
    }
    /* 按钮大小 */
    .button-size{
        height: 100%;
    }
</style>
